export default __webpack_public_path__ + "9fcd964bf4c39e0d274da765f79c9213.png";